export const BD_GET_DELIVEREDON_LISTING = "BD_GET_DELIVEREDON_LISTING"
export const BD_GET_DELIVEREDON_LISTING_SUCCESS = "BD_GET_DELIVEREDON_LISTING_SUCCESS"
export const BD_GET_DELIVEREDON_LISTING_FAILED = "BD_GET_DELIVEREDON_LISTING_FAILED"
